import { Injectable } from '@angular/core';

import {
  PaxFormControlBase,
  PaxFormControlTextbox,
  PaxFormControlDropdown,
  PaxFormControlRadio,
  BackendService
} from './../../shared/index';

@Injectable()
export class FormCustomerInformationService {
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  fieldOptions;

  constructor(
    private _backend: BackendService
  ) {
    // this._backend.getFormOptions().then(options => this.fieldOptions = options);
  }

  getQuestions() {
    // console.log(this.fieldOptions);

    // todo: get data from store?
    let questions: PaxFormControlBase<any>[] = [

      // Organization Structure
      new PaxFormControlDropdown({
        key: 'organizationStructure',
        label: 'Organization Structure',
        options: [
          { key: 'individual', value: 'Individual' },
          { key: 'corporation', value: 'Corporation' },
          { key: 'partnership', value: 'Partnership' },
          { key: 'llc', value: 'LLC' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // Named Insured
      new PaxFormControlTextbox({
        key: 'namedInsured',
        label: 'Named Insured',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2
      }),

      // DBA (Doing Business as)
      new PaxFormControlTextbox({
        key: 'dba',
        label: 'DBA',
        order: 3,
        tooltip: 'Doing Business as'
      }),

      // Address
      new PaxFormControlTextbox({
        key: 'address',
        label: 'Address',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 4
      }),

      // City
      new PaxFormControlTextbox({
        key: 'city',
        label: 'City',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 5
      }),

      // State
      new PaxFormControlDropdown({
        key: 'state',
        label: 'State',
        options: [
          { key: 'al', value: 'Alabama' },
          { key: 'ak', value: 'Alaska' },
          { key: 'az', value: 'Arizona' },
          { key: 'ar', value: 'Arkansas' },
          { key: 'ca', value: 'California' },
          { key: 'co', value: 'Colorado' },
          { key: 'ct', value: 'Connecticut' },
          { key: 'de', value: 'Delaware' },
          { key: 'fl', value: 'Florida' },
          { key: 'ga', value: 'Georgia' },
          { key: 'hi', value: 'Hawaii' },
          { key: 'id', value: 'Idaho' },
          { key: 'il', value: 'Illinois' },
          { key: 'in', value: 'Indiana' },
          { key: 'ia', value: 'Iowa' },
          { key: 'ks', value: 'Kansas' },
          { key: 'ky', value: 'Kentucky[D]' },
          { key: 'la', value: 'Louisiana' },
          { key: 'me', value: 'Maine' },
          { key: 'md', value: 'Maryland' },
          { key: 'ma', value: 'Massachusetts[E]' },
          { key: 'mi', value: 'Michigan' },
          { key: 'mn', value: 'Minnesota' },
          { key: 'ms', value: 'Mississippi' },
          { key: 'mo', value: 'Missouri' },
          { key: 'mt', value: 'Montana' },
          { key: 'ne', value: 'Nebraska' },
          { key: 'nv', value: 'Nevada' },
          { key: 'nh', value: 'New Hampshire' },
          { key: 'nj', value: 'New Jersey' },
          { key: 'nm', value: 'New Mexico' },
          { key: 'ny', value: 'New York' },
          { key: 'nc', value: 'North Carolina' },
          { key: 'nd', value: 'North Dakota' },
          { key: 'oh', value: 'Ohio' },
          { key: 'ok', value: 'Oklahoma' },
          { key: 'or', value: 'Oregon' },
          { key: 'pa', value: 'Pennsylvania[F]' },
          { key: 'ri', value: 'Rhode Island[G]' },
          { key: 'sc', value: 'South Carolina' },
          { key: 'sd', value: 'South Dakota' },
          { key: 'tn', value: 'Tennessee' },
          { key: 'tx', value: 'Texas' },
          { key: 'ut', value: 'Utah' },
          { key: 'vt', value: 'Vermont' },
          { key: 'va', value: 'Virginia[H]' },
          { key: 'wa', value: 'Washington' },
          { key: 'wv', value: 'West Virginia' },
          { key: 'wi', value: 'Wisconsin' },
          { key: 'wy', value: 'Wyoming' },
          { key: 'dc', value: 'District of Columbia' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 6
      }),

      // ZIP
      new PaxFormControlTextbox({
        key: 'zip',
        label: 'Zip',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 7
      }),

      // Email
      new PaxFormControlTextbox({
        key: 'email',
        label: 'Email',
        type: 'email',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }, {
          name: 'pattern',
          condition: this.emailPattern,
          message: 'Enter a valid email address'
        }],
        order: 8
      }),

      // Phone
      new PaxFormControlTextbox({
        key: 'phone',
        label: 'Phone',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        order: 9
      }),

      // Do you drive under your own authority (MC Number)
      new PaxFormControlRadio({
        key: 'mcNumber',
        label: 'Do you drive under your own authority (MC Number)',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 10
      }),

      // Do you hire drivers to operate your truck?
      new PaxFormControlRadio({
        key: 'doYouHireDrivers',
        label: 'Do you hire drivers to operate your truck?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 11
      }),

      // How many years of semi truck driving experience do you have?
      new PaxFormControlRadio({
        key: 'semiTruckExperience',
        label: 'How many years of semi truck driving experience do you have?',
        options: [
          { key: 1, value: '1' },
          { key: 2, value: '2' },
          { key: 3, value: '3' },
          { key: 4, value: '4' },
          { key: 5, value: '5+' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 12
      }),

      // Is there any existing damage to any of the units?
      new PaxFormControlRadio({
        key: 'isThereAnyDamage',
        label: 'Is there any existing damage to any of the units?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 13
      }),

      // Do you haul any of the following: autos, fuel, logs, garbage, coal, explosives, nuclear waste, flammables or life stock?
      new PaxFormControlRadio({
        key: 'doYouHaul',
        label: 'Do you haul any of the following: autos, fuel, logs, garbage, coal, explosives, nuclear waste, flammables or life stock?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 14
      }),

      // Do you use: Dump Trucks, Straight trucks, Pick ups ( hot shot units) , Panel or Cargo vans?
      new PaxFormControlRadio({
        key: 'doYouUse',
        label: 'Do you use: Dump Trucks, Straight trucks, Pick ups (hot shot units), Panel or Cargo vans?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 15
      }),

    ];

    return questions.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-customer-information/form-customer-information.service.ts